import { useState, useEffect } from 'react'

import { DropdownList } from '../../../GlobalComponents/Inputs/Inputs'
import { fetchVendorData, Vendors, Vendor } from '../../../features/inventory/inventoryAPI'
import { MenuItem } from '@material-ui/core'
import { SelectChangeEvent } from '@mui/material/Select'

interface VendorDropDownListProps {
    selectedValue: string
    onSelectedValueChanged(selectedValue: string): void
    [x: string]: any
}

const VendorDropDownList = (props: VendorDropDownListProps) => {
    const { onSelectedValueChanged, selectedValue, ...otherProps } = props
    const blankVendor: Vendor = {
        VendorID: '',
        VendorName: '',
        VendorIDName: '',
    }
    const [data, setData] = useState<Vendors>([])
    const [value, setValue] = useState<string>(selectedValue)

    useEffect(() => {
        async function getVendorData() {
            let vendData: Vendors = await fetchVendorData()
            if (vendData) {
                vendData.unshift(blankVendor)
                setData(vendData)
            }
        }
        getVendorData()
    }, [])

    const onChange = (e: SelectChangeEvent) => {
        setValue(e.target.value)
        onSelectedValueChanged(e.target.value)
    }

    return (
        <DropdownList {...otherProps} data={data} value={value} onChange={onChange}>
            {data?.map((vend, i) => {
                return (
                    <MenuItem key={`vendorDropDownList${i}`} value={vend.VendorID}>
                        {vend.VendorIDName}
                    </MenuItem>
                )
            })}
        </DropdownList>
    )
}

export default VendorDropDownList
